'use client';

import confetti from 'canvas-confetti';

/**
 * Triggers side cannons confetti effect
 * Fires confetti from both left and right sides of the screen
 */
export function triggerSideCannonsConfetti() {
  const end = Date.now() + 1 * 1000; // 1.5 seconds
  const colors = ['#a786ff', '#fd8bbc', '#eca184', '#f8deb1'];

  const frame = () => {
    if (Date.now() > end) return;

    // Left side cannon
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      startVelocity: 60,
      origin: { x: 0, y: 0.6 },
      colors: colors,
    });

    // Right side cannon
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      startVelocity: 60,
      origin: { x: 1, y: 0.6 },
      colors: colors,
    });

    requestAnimationFrame(frame);
  };

  frame();
}
